import React from "react";
import "./DataGate.css";

// Stands in for the panel until its data has come from the API, so screens
// never see an empty list that is only "not loaded yet".
export default function DataGate({ status, what, onRetry, children }) {
  if (status === "ready") return children;

  if (status === "failed") {
    return (
      <div className="data-gate" role="alert">
        <h2>Could not load {what}</h2>
        <p>The server did not answer. Check your connection and try again.</p>
        <button type="button" className="btn" onClick={onRetry}>
          Try again
        </button>
      </div>
    );
  }

  return (
    <div className="data-gate" aria-busy="true">
      <p>Loading {what}…</p>
    </div>
  );
}
